import React from 'react'
import DefaultForm from '../../forms/default-form'

const genericSuccessMessage = (currentOption, handleSuccess) =>
  handleSuccess(
    { [currentOption.value]: `${currentOption.label} is completed.` },
    currentOption.value
  )

const GovActionsForm = ({ currentOption, handleSuccess }) => {
  if (!currentOption.url) return null

  return (
    <DefaultForm
      url={currentOption.url}
      formOptions={currentOption.formOptions}
      value={currentOption.value}
      formComponent={currentOption.component}
      canDisplayErrors={currentOption.canDisplayErrors}
      label={currentOption.label}
      handleSuccess={() => genericSuccessMessage(currentOption, handleSuccess)}
    />
  )
}

export default GovActionsForm



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/form.jsx